import { Switch, Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { AccountStatus } from 'api/account';
import { PartnerCompany } from 'api/partner/types';
import { useAccount, useBillingFeatureFlag } from 'hooks/use-account';
import { useAvailableLicensesQuery } from 'queries/billing';
import { CellRendererParams } from './types';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

interface Props extends CellRendererParams {
  changeActiveStatus: (partner: PartnerCompany, active: boolean) => void;
}

export const PartnerActiveStatusRenderer: FC<Props> = ({
  value,
  data,
  changeActiveStatus,
}) => {
  const availableLicenses = useAvailableLicensesQuery();
  const isBillingEnabled = useBillingFeatureFlag();
  const { status: accountStatus } = useAccount();
  const isDisabled =
    value !== true &&
    accountStatus !== AccountStatus.Trial &&
    isBillingEnabled &&
    availableLicenses <= 0;

  return (
    <Tooltip
      title={
        isDisabled ? (
          <FormattedMessage id="partners.list.columns.status.disabled.message" />
        ) : null
      }
    >
      <Wrapper>
        <Switch
          disabled={isDisabled}
          checked={value}
          size="small"
          onChange={() => changeActiveStatus(data, !value)}
        />
        {value === true ? (
          <FormattedMessage id="active" />
        ) : (
          <FormattedMessage id="deactivated" />
        )}
      </Wrapper>
    </Tooltip>
  );
};

export const StatusSorter = (statusA: boolean, statusB: boolean): number =>
  Number(statusB) - Number(statusA);
